<div class="flag-down-rate full-width-height fdr-card">
  <mat-expansion-panel hideToggle="true" [expanded]="true" class="ci-expansion-panel fdr-panel">
    <mat-expansion-panel-header class="mep-header fdr-header" (click)="click()">
      <mat-panel-title class="fdr-title">
        <mat-icon class="fdr-toggle-icon">{{icon  ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
        <span class="fdr-category-name">{{vehicleCategory.categoryName}}</span>
      </mat-panel-title>
      <mat-panel-description *ngIf="!isDisabledForm" class="fdr-actions">
        <button type="button" mat-icon-button class="fdr-delete-btn"
                (click)="removeRate(); $event.stopPropagation()"
                aria-label="Delete rate">
          <img src="assets/booking-engine/icons/trash.svg" alt="delete" class="fdr-trash-icon">
        </button>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div class="ci-expansion-panel-content fdr-content">
      <form [formGroup]="flagDownRateForm">
        <div class="fdr-grid">
          <div class="fdr-field">
            <mat-checkbox formControlName="flagDownCostActivated" class="fdr-toggle">
              Flagdown Rate <span class="fdr-required">*</span>
            </mat-checkbox>
            <mat-form-field class="hmt-form-field" appearance="outline">
              <mat-label>Rate to Charge</mat-label>
              <input matInput type="number" formControlName="flagDownCost" hmtRestrictInputDecimalPlaces
                     decimalPlaces="2" [readonly]="!flagDownRateForm.get('flagDownCostActivated').value">
            </mat-form-field>
          </div>

          <div class="fdr-field">
            <mat-checkbox formControlName="flagDownFrequencyActivated" class="fdr-toggle">
              Flagdown Frequency <span class="fdr-required">*</span>
            </mat-checkbox>
            <mat-form-field class="hmt-form-field" appearance="outline">
              <mat-label>No of Hours</mat-label>
              <input matInput type="number" formControlName="flagDownFrequency" hmtRestrictInputDecimalPlaces
                     [readonly]="!flagDownRateForm.get('flagDownFrequencyActivated').value">
            </mat-form-field>
          </div>

          <div class="fdr-field">
            <mat-checkbox formControlName="jobFreeHoursActivated" class="fdr-toggle">
              Free Hours per FlagDown <span class="fdr-required">*</span>
            </mat-checkbox>
            <mat-form-field class="hmt-form-field" appearance="outline">
              <mat-label>No of Hours</mat-label>
              <input matInput type="number" formControlName="jobFreeHours" hmtRestrictInputDecimalPlaces
                     [readonly]="!flagDownRateForm.get('jobFreeHoursActivated').value">
            </mat-form-field>
          </div>

          <div class="fdr-field" *ngIf="!isFreezerContract">
            <mat-checkbox formControlName="sellingRatePerExtraKmActivated" class="fdr-toggle">
              Additional KM Rate <span class="fdr-required">*</span>
            </mat-checkbox>
            <mat-form-field class="hmt-form-field" appearance="outline">
              <mat-label>Rate of Charge</mat-label>
              <input matInput type="number" formControlName="sellingRatePerExtraKm" hmtRestrictInputDecimalPlaces
                     decimalPlaces="2" [readonly]="!flagDownRateForm.get('sellingRatePerExtraKmActivated').value">
            </mat-form-field>
          </div>

          <div class="fdr-field">
            <mat-checkbox formControlName="freeKmsPerFlagDownActivated" class="fdr-toggle">
              Free Km's per Flagdown <span class="fdr-required">*</span>
            </mat-checkbox>
            <mat-form-field class="hmt-form-field" appearance="outline">
              <mat-label>Number of Km's</mat-label>
              <input matInput type="number" formControlName="freeKmsPerFlagDown" hmtRestrictInputDecimalPlaces
                     decimalPlaces="3" [readonly]="!flagDownRateForm.get('freeKmsPerFlagDownActivated').value">
            </mat-form-field>
            <div class="fdr-hint" *ngIf="isFreezerContract">
              Acts as the minimum KM threshold when Freezer Billing is enabled.
            </div>
          </div>

          <div class="fdr-field" *ngIf="!isFreezerContract">
            <label class="fdr-label">Fuel Efficiency</label>
            <mat-form-field class="hmt-form-field" appearance="outline">
              <mat-label>Fuel Efficiency</mat-label>
              <input matInput type="number" formControlName="fuelEfficiency" hmtRestrictInputDecimalPlaces
                     decimalPlaces="3">
            </mat-form-field>
          </div>
        </div>

        <div class="fdr-section fdr-freezer-section" *ngIf="isFreezerContract">
          <h3 class="fdr-section-heading">Freezer Rates</h3>
          <div class="fdr-grid">
            <div class="fdr-field">
              <mat-checkbox formControlName="freezerOnRateActivated" class="fdr-toggle">
                Freezer On Rate (per KM) <span class="fdr-required">*</span>
              </mat-checkbox>
              <mat-form-field class="hmt-form-field" appearance="outline">
                <mat-label>Rate (per KM)</mat-label>
                <input matInput type="number" formControlName="freezerOnRate" hmtRestrictInputDecimalPlaces
                       decimalPlaces="2" [readonly]="!flagDownRateForm.get('freezerOnRateActivated').value">
              </mat-form-field>
              <div class="fdr-hint">Applied to legs where the freezer unit was running.</div>
            </div>

            <div class="fdr-field">
              <mat-checkbox formControlName="freezerOffRateActivated" class="fdr-toggle">
                Freezer Off Rate (per KM) <span class="fdr-required">*</span>
              </mat-checkbox>
              <mat-form-field class="hmt-form-field" appearance="outline">
                <mat-label>Rate (per KM)</mat-label>
                <input matInput type="number" formControlName="freezerOffRate" hmtRestrictInputDecimalPlaces
                       decimalPlaces="2" [readonly]="!flagDownRateForm.get('freezerOffRateActivated').value">
              </mat-form-field>
              <div class="fdr-hint">Applied to legs where the freezer unit was off.</div>
            </div>
          </div>

          <mat-checkbox formControlName="applyMinKmToFirstTripOnly" class="fdr-toggle fdr-section-toggle">
            Apply minimum KM to first trip only
          </mat-checkbox>

          <div class="fdr-info-banner" *ngIf="flagDownRateForm.get('applyMinKmToFirstTripOnly').value">
            <mat-icon class="fdr-info-icon">info</mat-icon>
            <span>First trip rule active. Trips under the minimum KM on the first completed trip per vehicle per
            calendar day will be topped up to the minimum at the Freezer On Rate. The system detects the first
            trip automatically.</span>
          </div>
        </div>

        <div class="fdr-section fdr-demurrage-section">
          <div class="demurrage">
            <mat-checkbox formControlName="demurragePerHrActivated" class="fdr-toggle fdr-section-toggle">Demurrage</mat-checkbox>

            <mat-radio-group class="demurrage-radio-group" formControlName="demurrageCalculationType"
                             *ngIf="demurragePerHrActivated">
              <div class="col">
                <mat-radio-button class="radio-btn" value="FULL_TRIP">Calculate Demurrage For the Complete trip
                </mat-radio-button>
                <mat-radio-button class="radio-btn" value="LOCATION_BASED">Location Based Demurrage Calculation
                </mat-radio-button>
              </div>

              <div class="check-box-group" *ngIf="dct === 'LOCATION_BASED'">
                <ul>
                  <li>
                    <mat-checkbox formControlName="demurragePublicLocation"
                                  [ngStyle]="{'color': checkLocationTypeSelected() ? '#FF0000' : '#000000'}">
                      Calculate Demurrage for Public Location
                    </mat-checkbox>
                  </li>
                  <li>
                    <mat-checkbox formControlName="demurrageOtherLocation"
                                  [ngStyle]="{'color': checkLocationTypeSelected() ? '#FF0000' : '#000000'}">
                      Calculate Demurrage for Private Location
                    </mat-checkbox>
                  </li>
                </ul>
              </div>
            </mat-radio-group>

            <!-- form array -->
            <div formArrayName="demurrageSlabs" class="col demurrage-slabs" *ngIf="demurragePerHrActivated">
              <ng-container *ngFor="let slab of getDemurrageSlabs()?.controls; let i=index">
                <div class="demurrage-slab" [formGroupName]="i">
                  <div class="next">{{ i == 0 ? 'First' : 'Next' }}</div>
                  <div class="hours">
                    <mat-form-field class="hmt-form-field" appearance="outline">
                      <input matInput type="number" formControlName="hours" placeholder="hours"
                             hmtRestrictInputDecimalPlaces>
                    </mat-form-field>
                  </div>
                  <div class="hours-label">hrs</div>
                  <div class="rate">
                    <mat-form-field class="hmt-form-field" appearance="outline">
                      <input matInput type="number" formControlName="rate" placeholder="Rate (per hr)"
                             hmtRestrictInputDecimalPlaces decimalPlaces="2">
                    </mat-form-field>
                  </div>
                  <button type="button" mat-icon-button class="remove-btn" *ngIf="!isDisabledForm"
                          (click)="removeDemurrageSlab(i)" aria-label="Remove slab">
                    <img src="assets/booking-engine/icons/trash.svg" alt="delete" class="fdr-trash-icon">
                  </button>
                </div>
              </ng-container>
            </div>
            <div class="add-slab" *ngIf="!isDisabledForm && demurragePerHrActivated">
              <button mat-stroked-button color="primary" class="fdr-add-btn" (click)="addDemurrageSlab()">
                <mat-icon>add</mat-icon>
                Add Slab
              </button>
            </div>
            <div class="demurrage-till-clearance" *ngIf="demurragePerHrActivated">
              <div class="label">Until Clearance Per Hour</div>
              <mat-form-field class="hmt-form-field form-input" appearance="outline">
                <input matInput type="number" placeholder="Rate (per hr)"
                       formControlName="demurragePerHrTillClearance" hmtRestrictInputDecimalPlaces decimalPlaces="2" [readonly]="isDisabledForm">
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="fdr-section fdr-costs-section">
          <h3 class="fdr-section-heading">Costs</h3>

          <div class="fdr-row-card">
            <div class="fdr-row-toggle">
              <mat-checkbox [checked]="isCheckBoxUseTier" formControlName="tierCostActivated"
                            (change)="toggleRadioButton(1)"></mat-checkbox>
            </div>
            <div class="fdr-row-label">Use Tier</div>
            <mat-form-field appearance="outline" class="hmt-form-field fdr-row-field">
              <input type="text"
                     placeholder="Select Tier"
                     aria-label="Number"
                     matInput
                     formControlName="vehicleTier"
                     [matAutocomplete]="auto"
                     [readonly]="!flagDownRateForm.get('tierCostActivated').value">
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                                [displayWith]="displayTierName.bind(this)">
                <ng-container *ngFor="let tier of rateTiers">
                  <mat-option [value]="tier.tierId" (click)="setVehicleTier(tier)">{{ tier.name }}</mat-option>
                </ng-container>
              </mat-autocomplete>
            </mat-form-field>
            <div class="fdr-row-actions">
              <button mat-stroked-button color="primary" class="fdr-applicable-btn" (click)="openCreateTier()"
                      *ngIf="!isDisabledForm && flagDownRateForm.get('tierCostActivated').value">
                Create Tier
              </button>
            </div>
          </div>

          <div class="fdr-row-card">
            <div class="fdr-row-toggle">
              <mat-checkbox [checked]="isCheckBoxFixedPrice" formControlName="perKmFixedPriceActivated"
                            (change)="toggleRadioButton(2)"></mat-checkbox>
            </div>
            <div class="fdr-row-label">Fixed Cost</div>
            <mat-form-field appearance="outline" class="hmt-form-field fdr-row-field">
              <mat-label>Fixed Running Cost per Km</mat-label>
              <input matInput type="number" formControlName="perKmFixedPrice" hmtRestrictInputDecimalPlaces
                     decimalPlaces="2" [readonly]="!flagDownRateForm.get('perKmFixedPriceActivated').value">
            </mat-form-field>
            <div class="fdr-row-actions"></div>
          </div>
        </div>
      </form>
    </div>
  </mat-expansion-panel>
</div>
